<template>
  <div class="icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="ionicon"
      viewBox="0 0 512 512"
    >
      <title>Chevron Forward</title>
      <path
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="48"
        d="M184 112l144 144-144 144"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Right",
};
</script>

<style scoped lang="scss">
.icon {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/icons/Right.vue